/**
 * CSV出力区分
 */
export const CSVOutputConst = 
{
  /**
   * 基幹システム
   */
  CORE_SYSTEM: 1,
  /**
   * サイネージ
   */
  SINAGE: 2,
} as const;
export type  CSVOutputType = typeof CSVOutputConst[keyof typeof CSVOutputConst];